import * as React from 'react';
import './legend.scss';
import { useActions } from '../viewActions';
import { ProgressBar } from '../../ProgressBar/progressBar';
import { Close, Icon } from 'rcd-cpp-ui/ui/icon';
import { AppRefId } from '../../../utils/constants';
import { NodeType } from '../../../enums/NodeType';
import { useSelector } from '../../../utils/useSelector';

export const Legend = () => {
  const showLegend = useSelector(s => {
    const userSettings = s.planning?.userSettings;
    if (!userSettings) return null;
    const view = s.view?.selected;
    if (!view?.props) return null;
    if (view.props.data != NodeType.Item) return null;
    const viewSetting = userSettings[view.props.refId];
    const appSetting = userSettings[AppRefId];
    return (
      !viewSetting?.props?.hideItemProgress &&
      !appSetting?.props?.hideProgressLegend
    );
  });
  const { setViewSettings } = useActions();
  if (!showLegend) return null;

  return (
    <div className="view-legend">
      <div>
        <div>
          <div>Idea</div>
          <ProgressBar className="workflow-bar-idea" />
        </div>
        <div>
          <div>Concept Review</div>
          <ProgressBar className="workflow-bar-conceptreview" />
        </div>
        <div>
          <div>Not Pursued</div>
          <ProgressBar className="workflow-bar-notpursued" />
        </div>
        <div>
          <div>Authoring</div>
          <ProgressBar className="workflow-bar-cat2" />
        </div>
        <div>
          <div>R&A Studio</div>
          <ProgressBar className="workflow-bar-cat3" />
        </div>
        <div>
          <div>Published/Completed</div>
          <ProgressBar className="workflow-bar-cat4" />
        </div>
        <div>
          <div>Archived</div>
          <ProgressBar className="workflow-bar-archived" />
        </div>
        <div>
          <div>Retracted</div>
          <ProgressBar className="workflow-bar-retracted" />
        </div>
      </div>
      <Icon
        onClick={() => {
          setViewSettings({ hideProgressLegend: true }, AppRefId);
        }}
      >
        <Close />
      </Icon>
    </div>
  );
};
